var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowIcon = function SvgArrowIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0573 23.219L5.724 13.8856L7.60962 12L16.0001 20.3905L24.3907 12L26.2763 13.8856L16.943 23.219C16.4223 23.7397 15.578 23.7397 15.0573 23.219Z",
    fill: "#767676"
  })));
};
export { SvgArrowIcon as ReactComponent };
export default __webpack_public_path__ + "assets/c52b6e0c.svg";